<template>
  <div class="mira-login">
    <!-- 标题 -->
    <div class="mira-title">
      <span> MiraPlay · Web</span>
    </div>
    <!-- 表单 -->
    <div class="mira-form">
      <div class="mira-form-input">
        <el-input v-model="formData.logincode" size="medium" :placeholder="this.$t('login_user_need_email')" >
          <template #prefix>
            <span class="el-input__prefix">
              <img src="../../../static/images/login/email.png" class="input-icon" alt="email">
            </span>
          </template>
        </el-input>
      </div>
      <div class="mira-form-input">
        <el-input v-model="formData.password" size="medium" show-password :placeholder="this.$t('login_need_password')" >
          <template #prefix>
            <span class="el-input__prefix">
              <img src="../../../static/images/login/password.png" class="input-icon" alt="password">
            </span>
          </template>
        </el-input>
      </div>
      <div class="esp-form-register clearfix">
        <div>
          <span @click="showRegisterDialog">{{this.$t("login_register")}}</span>
        </div>
      </div>
      <div class="mira-form-button">
        <el-button type="primary" @click="doLogin" size="medium" class="purple-login-btn">
          <span>{{$t("Login")}}</span>
        </el-button>
      </div>
      <div class="age-confirm-label">
          {{ $t('login_terms_and_conditions') }}
      </div>
      <div class="age-confirm-checkbox">
        <el-checkbox v-model="ageConfirmed">
          {{ $t('login_terms_and_conditions_confirm') }}
        </el-checkbox>
      </div>
      <div class="mira-form-divider">
        <span>{{$t("login_or")}}</span>
      </div>
      <div class="mira-form-google">
        <el-button plain size="medium" @click="googleLogin">
          <img src="../../../static/images/login/google.png" class="google-icon" alt="Google">&nbsp;&nbsp;&nbsp;
          <span>Login with Google</span>
        </el-button>
      </div>
      <div class="mira-form-google">
        <el-button plain size="medium" @click="appleLogin">
          <img src="../../../static/images/login/apple.png" class="apple-icon" alt="Apple">&nbsp;&nbsp;&nbsp;
          <span>Login with Apple</span>
        </el-button>
      </div>
      <div class="recommended">
        <span>{{$t("login_recommended_to_use_chrome_browser1")}}</span>
      </div>
      <div class="recommended2">
        <span>{{$t("login_recommended_to_use_chrome_browser2")}}</span>
      </div>
    </div>

    <!-- 注册对话框 -->
    <el-dialog
      :title="this.$t('login_register')"
      :visible.sync="registerDialogVisible" width="500px" center class="register-dialog-overlay">
        <div class="register-options">
          <div class="form-item">
            <label class="input-label">{{$t('login_user_email')}}</label>
            <el-input
              v-model="registerForm.email"
              size="medium"
              :placeholder="$t('login_user_need_email')"
              class="register-input"
            ></el-input>
          </div>
          <div class="form-item">
            <label class="input-label">{{$t('login_password')}}</label>
            <el-input
              v-model="registerForm.password"
              size="medium"
              type="password"
              show-password
              :placeholder="$t('login_need_password')"
              class="register-input"
            ></el-input>
          </div>
          <div class="form-item">
            <label class="input-label">{{$t('profile_confirm_password')}}</label>
            <el-input
              v-model="registerForm.confirmPassword"
              size="medium"
              type="password"
              show-password
              :placeholder="$t('profile_need_confirm_password')"
              class="register-input"
            ></el-input>
          </div>
        </div>
        <div class="register-dialog-buttons">
          <button class="dialog-btn cancel-btn" @click="cancelRegister">{{$t("layout_cancel")}}</button>
          <button class="dialog-btn confirm-btn" @click="handleRegister">{{$t("layout_confirm")}}</button>
        </div>
      </el-dialog>

    <el-dialog
      :visible.sync="registerSuccessDialogVisible" width="500px" center class="register-dialog-overlay2">
      <div class="register-options">
        <div class="form-item">
          <label class="input-label2 text-center">{{$t('register_successfully')}}</label>
        </div>
        <div class="form-item">
          <label class="input-label2 text-center">{{$t('user_trial_period_prompt')}}</label>
        </div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import * as auth from "@/api/platform/auth";
import * as cache from "@/utils/cache";
import CryptoJS from 'crypto-js';
import { setup } from "../../locales";
import { googleAuth, googleProvider, appleProvider } from "@/utils/googleLogin";
export default {
  name: "login",
  data() {
    return {
      formData: {
        logincode: "",
        password: "",
        pwd: ""
      },
      formGoogle: {
        loginMedthod:"",
        googleId: "",
        userId: "",
        displayName: "",
        creationDatestr:""
      },
      formApple: {
        loginMedthod:"",
        iosId: "",
        userId: "",
        displayName: "",
        creationDatestr:""
      },
      // 注册相关数据
      registerDialogVisible: false,
      registerSuccessDialogVisible: false,
      registerLoading: false,
      registerForm: {
        email: "",
        password: "",
        confirmPassword: ""
      },
      ageConfirmed: false, // 年龄确认状态
    }
  },

  created() {
    this.getLanguage();
  },
  methods: {
    // 显示注册对话框
    showRegisterDialog() {
      console.log('showRegisterDialog called'); // 添加这行
      this.registerForm = {
        email: "",
        password: "",
        confirmPassword: ""
      };
      this.registerDialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.registerFormRef) {
          this.$refs.registerFormRef.clearValidate();
        }
      });
    },
    cancelRegister() {
      this.registerDialogVisible = false;
    },
    // 处理注册
    handleRegister() {
      // 验证邮箱
      if (!this.registerForm.email) {
        this.$message({type: "error", message: this.$t('login_user_need_email')});
        return;
      }
      //邮箱格式
      if (!this.validateEmail(this.registerForm.email)){
        this.$message({type: "error", message: this.$t('login_account_valid_warning1')});
        return;
      }
      // 验证密码表单
      if (!this.registerForm.password) {
        this.$message({type: "error", message: this.$t('login_need_password')});
        return;
      }
      if (this.registerForm.password.length<8 || this.registerForm.password.length>16) {
        this.$message({type: "error", message: this.$t('profile_password_valid_warning2')});
        return;
      }
      if (!this.registerForm.confirmPassword) {
        this.$message({type: "error", message: this.$t('profile_need_confirm_password')});
        return;
      }
      if (this.registerForm.password !== this.registerForm.confirmPassword) {
        this.$message({type: "error", message: this.$t('profile_password_valid_warning1')});
        return;
      }

      const hash = CryptoJS.MD5(this.registerForm.password);
      const base64EncodedOld = CryptoJS.enc.Base64.stringify(hash);

      // 准备注册数据
      const registerData = {
        logincode: this.registerForm.email,
        pwd: base64EncodedOld
      };

      // 调用注册API
      auth.register(registerData).then(result => {
        // this.$message({
        //   duration: 1500,
        //   message: this.$t('register_successfully'),
        //   type: 'success'
        // });
        this.registerDialogVisible = false;
        this.registerSuccessDialogVisible = true;
      }).catch(error => {
      }).finally(() => {
        this.registerLoading = false;
      });
    },
    // 登录
    doLogin: function () {
      // 年龄验证
      if (!this.ageConfirmed) {
        this.$message({type: "error", message: this.$t('login_terms_and_conditions_check')});
        return;
      }
      if (!this.formData.logincode) {
        this.$message({type: "error", message: this.$t('login_user_need_email')});
        return;
      }
      //邮箱格式
      if (!this.validateEmail(this.formData.logincode)){
        this.$message({type: "error", message: this.$t('login_account_valid_warning1')});
        return;
      }
      if (!this.formData.password) {
        this.$message({type: "error", message: this.$t('login_need_password')});
        return;
      }
      const hash = CryptoJS.MD5(this.formData.password);
      const base64Encoded = CryptoJS.enc.Base64.stringify(hash);
      this.formData.pwd = base64Encoded;
      const loading = this.$loading(this.espConstant.loadingType);
      auth.regTokenPc(this.formData).then(result => {
        loading.close();
        cache.regAuth(result.data)
        this.$router.push({path: "/espindex"});
      }).catch(error => {
        loading.close();
      });
    },
    async googleLogin() {
      try {
        // 年龄验证
        if (!this.ageConfirmed) {
          this.$message({type: "error", message: this.$t('login_terms_and_conditions_check')});
          return;
        }
        const loading = this.$loading(this.espConstant.loadingType);
        googleAuth.signInWithPopup(googleProvider).then(result => {
          const user = result.user;
          const uid = user.uid; // Google账号的UID
          const email = user.email;
          const displayName = user.displayName;
          this.formGoogle.userId = user.uid;
          this.formGoogle.googleId = user.email;
          this.formGoogle.loginMedthod = "Google";
          this.formGoogle.displayName = user.displayName;
          this.formGoogle.creationDatestr = this.formatTime(new Date());

          if(result.user){
            // 发送到您的后端API
            auth.loginWithGoogle(this.formGoogle).then(result => {
              loading.close();
              cache.regAuth(result.data)
              this.$router.push({path: "/espindex"});
            }).catch(error => {
              loading.close();
            });
          }
        }).catch(error => {
          loading.close();
        });
      } catch (error) {
        loading.close();
      }
    },
    async appleLogin() {
      try {
        // 年龄验证
        if (!this.ageConfirmed) {
          this.$message({type: "error", message: this.$t('login_terms_and_conditions_check')});
          return;
        }
        const loading = this.$loading(this.espConstant.loadingType);
        googleAuth.signInWithPopup(appleProvider).then((result) => {
          const credential = result.credential;
          const user = result.user;
          const uid = user.uid; // Google账号的UID
          const email = user.email;
          const displayName = user.displayName;
          this.formApple.userId = user.providerData[0].uid;
          this.formApple.iosId = user.providerData[0].uid;
          this.formApple.loginMedthod = "Apple";
          this.formApple.displayName = user.displayName;
          this.formApple.creationDatestr = this.formatTime(new Date());

          if(result.user){
            // 发送到您的后端API
            auth.loginWithGoogle(this.formApple).then(result => {
              loading.close();
              cache.regAuth(result.data)
              this.$router.push({path: "/espindex"});
            }).catch(error => {
              loading.close();
            });
          }

        }).catch((error) => {
          loading.close();
        });

      } catch (error) {
        loading.close();
      }
    },
    formatTime(date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')

      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    },
    getLanguage() {
      const navLang = (navigator.language || navigator.userLanguage).split('-')[0]
      console.log('Detected browser language:', navLang)

      // 支持的语言列表
      const supportedLangs = ['ja', 'en']

      // 如果浏览器语言是支持的语言之一，则使用它
      if (supportedLangs.includes(navLang)) {
        this.changeLanguage(navLang)
      } else {
        // 否则使用默认语言
        this.changeLanguage('en')
      }
    },
    async changeLanguage(lang) {
      try {
        // 确保 setup 函数返回 Promise 并且正确加载语言包
        await setup(lang);

        // 确保 VueI18n 实例已正确设置
        if (this.$i18n) {
          this.$i18n.locale = lang;
        } else {
          console.error('i18n instance not available');
        }

        // 强制更新视图
        this.$forceUpdate();
      } catch (error) {
        console.error('Failed to change language:', error);
      }
    },
    validateEmail(email) {
      // 正则表达式模式
      const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return pattern.test(email);
    },
  },
  watch: {
    $route(to, from) {
      if (this.$route.path == "" || this.$route.path == "/login") {
        this.getLanguage();
      }
    }
  }
}
</script>

<style scoped>
/* 整体样式 */
.mira-login {
  width: 100%;
  height: 100vh;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  display: flex;
  background: url("../../../static/images/login/bg.png") no-repeat center center;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-size: 100% 100%;
}
/* 标题 */
.mira-title {
  margin-bottom: 20px;
  font-size: 36px;
  font-weight: 500;
  color: #333;
}
/* 紫色登录按钮 */
.purple-login-btn {
  background-color: #8300F6;
  border-color: #8300F6;
}
.purple-login-btn:hover,
.purple-login-btn:focus {
  background-color: #7200D6;
  border-color: #7200D6;
}
.purple-login-btn:active {
  background-color: #6200B6;
  border-color: #6200B6;
}
/* 表单容器 */
.mira-form {
  width: 380px;
  border-radius: 8px;
  padding: 30px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}
/* 图标容器样式 */
.icon-container {
  display: flex;
  align-items: center;
  height: 100%;
  padding-left: 5px; /* 控制图标与左边框的距离 */
}

/* 输入框图标样式 */
.input-icon {
  width: 16px;
  height: 16px;
  margin-left: 5px;
  margin-right: 15px; /* 控制图标向右移动的距离 */
}
/* 输入框容器 */
.mira-form-input {
  margin-bottom: 15px;
  position: relative;
  height: 44px;
  line-height: 44px;
  border-radius: 4px;
}

/* 前缀图标容器 */
.mira-form-input .el-input__prefix {
  left: 5px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
}

/* 图标样式 */
.mira-form-input .input-icon {
  width: 16px;
  height: 16px;
}

/* 占位文字调整 */
.mira-form-input .el-input__inner::placeholder {
  color: #c0c4cc;
  padding-left: 40px; /* 微调占位文字位置 */
}

/* 调整前缀容器样式 */
.mira-login .el-input__prefix {
  display: flex;
  align-items: center;
  left: 0;
  height: 100%;
}
/* 登录按钮 */
.mira-form-button {
  margin-bottom: 20px;
  background-color:#8300F6;
  border-radius: 6px;
}

.mira-form-button .el-button {
  width: 100%;
}

/* 分隔线 */
.mira-form-divider {
  position: relative;
  margin: 20px 0;
  text-align: center;
  color: #FFFFFF;
  font-size: 14px;
}

.mira-form-divider:before,
.mira-form-divider:after {
  content: "";
  position: absolute;
  top: 50%;
  width: 45%;
  height: 1px;
  background-color: #eee;
}

.mira-form-divider:before {
  left: 0;
}

.mira-form-divider:after {
  right: 0;
}

/* Google登录按钮 */
.mira-form-google .el-button {
  width: 100%;
  border: 1px solid #ddd;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 15px;
}

/* Google按钮内容容器 */
.google-btn-content {
  display: flex;
  align-items: center;
  gap: 8px;
}

/* Google图标样式 */
.google-icon {
  width: 18px;
  height: 18px;
  align-items: center;
}
.apple-icon {
  width: 20px;
  height: 20px;
  align-items: center;
}
</style>

<style>
.mira-login .mira-form-input .el-input__inner {
  height: 44px;
  line-height: 44px;
  border-radius: 6px;
}

.mira-login .el-input--medium .el-input__icon {
  line-height: 44px;
}

.mira-login .mira-form-button .el-button {
  height: 44px;
  font-size: 16px;
  border-radius: 6px;
}

.mira-login .mira-form-google .el-button {
  height: 44px;
  font-size: 16px;
  color: #333;
  border-radius: 6px;
}
.recommended {
  margin-top: 15px;
  font-size: 11px;
  color: #AA81FF;
  align-items: center;
  justify-content: center;
}
.recommended2 {
  font-size: 11px;
  color: #AA81FF;
  align-items: center;
  justify-content: center;
}

/* 输入框标签样式 */
.input-label {
  width: 180px;
  display: block;
  margin-top: 8px;
  font-size: 14px;
  color: #606266;
}

/* 输入框样式 */
.register-input {
  width: 100%;
}

.esp-form-register span {
  color: #8300F6;
  cursor: pointer;
  font-size: 12px;
  display: inline-block; /* 使span可以设置margin */
  margin-bottom: 15px;
}

.register-dialog-overlay .el-dialog__header {
  text-align: left;
  padding-left: 35px;
  height: 40px; /* 设置固定高度 */
  display: flex;
  align-items: center; /* 垂直居中 */
}

.register-dialog-overlay .el-dialog__title {
  font-family: PingFangSC-Semibold;
  font-size: 16px;
  color: #333333;
  letter-spacing: 0;
  font-weight: 600;
  line-height: 1; /* 移除默认行高 */
  margin: 0; /* 移除默认外边距 */
}
.register-prompt {
  display: flex;
  justify-content: left; /* 水平居中 */
  font-family: PingFangSC-Regular;
  font-size: 12px;
  color: #9A9A9A;
  letter-spacing: 0;
  font-weight: 400;
}

.register-dialog {
  background-color: white;
  padding: 30px;
  border-radius: 8px;
  width: 450px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.dialog-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 20px;
  display: block;
  text-align: center;
}

.register-options {
  margin-bottom: 20px;
}

/* 每个表单项独占一行 */
.form-item {
  margin-bottom: 15px;
  display: flex;
  align-items: flex-start;
  padding-left: 20px;
  padding-right: 20px;
}

/* 输入框标签样式 */
.input-label {
  display: block;
  margin-bottom: 8px;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #333333;
  letter-spacing: 0;
  font-weight: 400;
}

/* 输入框样式 */
.register-input {
  width: 100%;
}

.register-dialog-buttons {
  display: flex;
  justify-content: center; /* 水平居中 */
  gap: 30px; /* 加大按钮之间间隔，你可以根据需要调整数值 */
  margin-top: 10px;
}
.dialog-btn {
  padding: 8px 35px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}
.cancel-btn {
  background-color: #F4F3F1;
  color: #AA81FF;
  border: 1px solid #AA81FF;
}

.cancel-btn:hover {
  background-color: #e0e0e0;
}
.hint-icon {
  width: 14px;
  height: 14px;
  margin-right: 3px;
}
.confirm-btn {
  background-color: #AA81FF;
  color: white;
  border: none;
}

.confirm-btn:hover {
  background-color: #7200D6;
}
/* 年龄确认复选框样式 */
.age-confirm-label{
  margin: 5px 0 8px 0; /* 上 右 下 左 */
  text-align: left;
  color: #AA81FF;
  font-size: 12px;
}
.age-confirm-checkbox {
  margin: 0 0 15px 0; /* 上 右 下 左 */
  text-align: left;
}

.age-confirm-checkbox .el-checkbox {
  color: #AA81FF;
}

.age-confirm-checkbox .el-checkbox__label {
  font-size: 12px;
}
.register-dialog-overlay2 .el-dialog__header {
  text-align: center;
  padding-left: 35px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center; /* 添加这行确保标题居中 */
}

.register-dialog-overlay2 .el-dialog__title {
  font-family: PingFangSC-Semibold;
  font-size: 16px;
  color: #333333;
  letter-spacing: 0;
  font-weight: 600;
  line-height: 1;
  margin: 0;
}

/* 添加这个新样式类 */
.text-center {
  text-align: center;
  width: 100%;
}

/* 修改input-label2样式 */
.input-label2 {
  display: block;
  margin-top: 8px;
  font-size: 14px;
  color: #606266;
  width: 100%; /* 确保宽度100% */
  text-align: center; /* 文字居中 */
}

/* 确保form-item内容居中 */
.form-item {
  display: flex;
  justify-content: center;
  width: 100%;
  padding-left: 0;
  padding-right: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/login/login.vue